import { create } from 'zustand';

interface PhoneNumbersStore {
  phoneNumbers: string[];
  setPhoneNumbers: (value: string[]) => void;
  shownNumbersAdsIds: Set<string>;
  addShownNumbersAdId: (adId: string) => void;
  removeShownNumbersAdId: (adId: string) => void;
}

export const usePhoneNumbersStore = create<PhoneNumbersStore>(set => ({
  phoneNumbers: [],
  setPhoneNumbers: value => set({ phoneNumbers: value }),
  shownNumbersAdsIds: new Set(),
  addShownNumbersAdId: adId =>
    set(state => ({
      shownNumbersAdsIds: new Set(state.shownNumbersAdsIds).add(adId),
    })),
  removeShownNumbersAdId: adId =>
    set(state => {
      state.shownNumbersAdsIds.delete(adId);
      return {
        shownNumbersAdsIds: new Set(state.shownNumbersAdsIds),
      };
    }),
}));
